import { toast } from 'react-toastify';
import _ from "lodash";
import { StateMachineManager } from '../utils/stateMachine';
import APIUrls from "../constants/ApiUrls";
import { APIManager } from "../utils/api";
import { SearchClient } from "../lib/SearchClient";
import { addEventNameToEndpoint } from "../utils/common";

// ITEMS
import {
  GET_ITEMS,
  DELETE_ITEM,
  UPDATE_ITEM,
  GET_ITEM_DETAIL,
  SHARE_ITEM,
  UPVOTE_ITEM,
  DELETE_UPVOTE_ITEM,
  FAVORITE_ITEM,
  DELETE_FAVORITE_ITEM,
  UPDATE_SHORT_URL,
  ADD_TAG_TO_ITEM,
  UPDATE_TAGS_FOR_ITEMS,
  REMOVE_TAG_FROM_ITEM,
  GET_IMPORT_HISTORY,
  UPDATE_HISTORY_STATUS,
  DELETE_IMPORT_HISTORY,
  CREATE_IMPORT_HISTORY,
  getItems,
  getItemsFail,
  getItemsSuccess,
  deleteItemFail,
  updateItemSuccess,
  updateItemFail,
  getItemDetailSuccess,
  getItemDetailFail,
  getItemDetail,
  shareItemSuccess,
  updateShortUrlSuccess,
  getImportHistorySuccess,
  getImportHistoryFailure,
  createImportHistorySuccess,
  createImportHistoryFailure,
  updateHistoryStatusSuccess,
  updateHistoryStatusFailure,
  deleteImportHistorySuccess,
  deleteImportHistoryFailure
} from "../actions/items";

// WISHES
import {
  GET_WISHLIST,
  GET_WISH_DETAIL,
  ADD_WISH,
  UPDATE_WISH,
  DELETE_WISH,
  ADD_UPVOTE_WISH,
  DELETE_UPVOTE_WISH,
  getWishDetailSuccess,
  getWishDetailFailure,
  getWishsSuccess,
  addWishSuccess,
  updateWishSuccess,
  deleteWishSuccess,
  deleteUpvoteWishSuccess,
  addUpvoteWishSuccess,
  getWishsFail,
} from "../actions/wishs";

// SETTINGS
import {
  FETCH_SETTINGS,
  UPDATE_SETTING,
  ADD_FUNNEL_STAGE,
  ADD_FUNNEL_STAGES,
  ADD_CONTENT_PRODUCT,
  ADD_CONTENT_PRODUCTS,
  ADD_CONTENT_INDUSTRIES,
  ADD_CONTENT_INDUSTRY,
  ADD_CONTENT_REGION,
  ADD_CONTENT_REGIONS,
  UPDATE_FUNNEL_STAGE,
  UPDATE_CONTENT_PRODUCT,
  UPDATE_CONTENT_INDUSTRY,
  UPDATE_CONTENT_REGION,
  ADD_CONTENT_TYPE,
  ADD_CONTENT_TYPES,
  UPDATE_CONTENT_TYPE,
  ADD_CONTENT_TAG,
  ADD_CONTENT_TAGS,
  UPDATE_CONTENT_TAG,
  INVITE_USER,
  DELETE_USER,
  GET_USERS,
  DELETE_SETTINGS_ITEM,
  UPDATE_SHORT_DOMAIN,
  GET_INVOICES,
  GET_USER_INFO,
  UPDATE_DIGEST_OPTION,
  UPDATE_ACCOUNT_APP_SETTINGS,
  CREATE_NEW_COLLECTION,
  UPDATE_COLLECTION,
  DELETE_COLLECTION,
  GET_COLLECTIONS,
  GET_COLLECTION,
  ADD_ITEM_TO_COLLECTION,
  REMOVE_ITEM_FROM_COLLECTION,
  UPDATE_ITEMS_OF_COLLECTION,
  CREATE_SITE,
  GET_USER_SITE_CONTENT,
  DELETE_SITE,
  UPDATE_BRANDING_COLOR,
  UPDATE_TRACKERS,
  UPDATE_USER_ROLE,
  fetchSettingsFail,
  fetchSettingsSuccess,
  getUsersSuccess,
  getUsersFail,
  getUserInfoSuccess,
  getUserInfo,
  getUsers,
  deleteSettingsItemSuccess,
  updateShortDomainSuccess,
  updateShortDomainFail,
  setLoading,
  getInvoicesSuccess,
  getInvoicesFail,
  updateDigestOptionSuccess,
  updateDigestOptionFail,
  createNewCollectionFail,
  deleteCollectionFail,
  getCollectionsSuccess,
  getCollectionsFail,
  getCollectionSuccess,
  getCollectionFail,
  createSiteSuccess,
  createSiteFail,
  getUserSiteContentSuccess,
  getUserSiteCOntentFail,
  deleteSiteFail
} from "../actions/settings";

// AUTH
import {
  GET_CURRENT_COGNITO_USER,
  CHANGE_ATTRIBUTE,
  CHANGE_USER_ATTRIBUTE,
  USER_LOGOUT,
  UPDATE_TENANT,
  cognitoLoginSuccess,
  changeUserAttributeSuccess,
  cognitoLoginFail,
  loginSuccess,
  logout
} from "../actions/auth";

// ACTIVITY
import {
  GET_ACTIVITIES,
  DIGEST_NOTIFICATION_TEST,
  getActivitiesSuccess,
  getActivitiesFail
} from "../actions/activity";

// CTAS
import {
  GET_CTAS_LIST,
  CREATE_CTA,
  UPDATE_CTA,
  DELETE_CTA,
  getCtasListSuccess,
  deleteCtaSuccess,
  getCtasList,
} from "../actions/ctas";

import {
  GET_SUBSCRIPTIONS,
  getSubscriptions,
  getSubscriptionsSuccess,
  getSubscriptionsFail,
  CREATE_SUBSCRIPTION,
  createSubscriptionsSuccess,
  createSubscriptionFail,
  UPDATE_SUBSCRIPTION,
  updateSubscriptionsSuccess,
  updateSubscriptionFail,
  DELETE_SUBSCRIPTION,
  deleteSubscriptionsSuccess,
  deleteSubscriptionFail
} from "../actions/subscription";

const AuthorizedMiddleware = ({ getState, dispatch }) => next => async (action) => {
  let axiosConfig = {};

  // SearchClient.getClient(this.props.tenant.tenantId, this.props.tenant.algoliaPublicKey, searchOptions);


  if (getState().auth.tenant && getState().auth.cognitoUser) {
    try {
      // set up the authorized requests
      if (getState().auth.Auth && getState().auth.Auth.currentSession) {
        const tokens = await getState().auth.Auth.currentSession();

        axiosConfig = {
          headers: {
            'Authorization': `Bearer ${tokens.accessToken.jwtToken}`,
            'X-Identity': tokens.idToken.jwtToken,
            "Content-Type": "application/json",
          },
          crossdomain: true
        }
      }
    } catch (e) {
      dispatch(logout());
    }
  }

  switch (action.type) {
    // /////////////////////////////
    // WEBHOOK SUBSCRIPTIONS
    
    case GET_SUBSCRIPTIONS: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.subscriptions(action.tenantId), axiosConfig);
        const data = response || [];
        dispatch(getSubscriptionsSuccess(data));
      } catch (e) {
        dispatch(getSubscriptionsFail(e.message));
      }

      return next(action);
    }

    case CREATE_SUBSCRIPTION: {
      try {
        await APIManager.Instance.call("POST", APIUrls.subscriptions(action.subscriptionData.tenantId), axiosConfig, action.subscriptionData);
        dispatch(createSubscriptionsSuccess(action.subscriptionData));
        dispatch(getSubscriptions(action.subscriptionData.tenantId));
      } catch (e) {
        dispatch(createSubscriptionFail(e.message));
      }

      return next(action);
    }

    case UPDATE_SUBSCRIPTION: {
      try {
        await APIManager.Instance.call("PUT", APIUrls.editSubscription(action.subscriptionData.tenantId, action.subscriptionData.subscriptionId), axiosConfig, action.subscriptionData);
        dispatch(getSubscriptions(action.subscriptionData.tenantId));
        dispatch(updateSubscriptionsSuccess(action.subscriptionData));
      } catch (e) {
        dispatch(updateSubscriptionFail(e.message));
      }

      return next(action);
    }
    
    case DELETE_SUBSCRIPTION: {
      try {
        await APIManager.Instance.call("DELETE", APIUrls.deleteSubscriptions(action.subscriptionData.tenantId), axiosConfig, action.subscriptionData);
        dispatch(deleteSubscriptionsSuccess(action.subscriptionData));
        dispatch(getSubscriptions(action.subscriptionData.tenantId));
      } catch (e) {
        dispatch(deleteSubscriptionFail(e.message));
      }

      return next(action);
    }

    // /////////////////////////////
    // ITEMS
    case GET_ITEMS: {
      if (!getState().auth.cognitoUser) return next(action);

      // make sure the search client is ready to go
      // const tenantId = getState().auth.tenant.tenantId;
      // const algoliaPublicKey = getState().auth.tenant.algoliaPublicKey;
      // const searchOptions = _.get(getState().settings, "userInfo.searchOptions", []);
      // const searchClient = SearchClient.getClient(tenantId, algoliaPublicKey, searchOptions);

      try {
        // const response = await searchClient.getAllItems(); //await APIManager.Instance.call("GET", APIUrls.items, axiosConfig);
        const response = await APIManager.Instance.call("GET", APIUrls.items, axiosConfig);

        dispatch(getItemsSuccess(response));
      } catch (e) {
        dispatch(getItemsFail(e.message));
        toast.error("Failed to load items: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    
    case DELETE_ITEM: {
      try {
        await APIManager.Instance.call("DELETE", APIUrls.updateItem(action.id), axiosConfig);
        // dispatch(deleteItemSuccess(action.id));
      } catch (e) {
        dispatch(deleteItemFail(e.message));
        toast.error("Failed to delete item: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case FETCH_SETTINGS: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.getAccountSettings, axiosConfig);

        dispatch(fetchSettingsSuccess(response));
      } catch (e) {
        dispatch(fetchSettingsFail(e.message));
        toast.error("Failed to load account settings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_ITEM: {
      APIManager.Instance.call("PUT", APIUrls.updateItem(action.newDetails.id), axiosConfig, action.newDetails)
        .then(() => {
          dispatch(updateItemSuccess(action.newDetails));

          toast.success("Updated item successfully!", {
            position: toast.POSITION.TOP_RIGHT,
          });
        })
        .catch((e) => {
          dispatch(updateItemFail(e.message, action.newDetails.id));
          toast.error("Failed to update item: " + e.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });

      return next(action);
    }
    case GET_CURRENT_COGNITO_USER: {
      try {
        const response = await getState().auth.Auth.currentUserInfo();
        dispatch(cognitoLoginSuccess(response));
      } catch (e) {
        dispatch(cognitoLoginFail(e.message));
        toast.error("Failed to get current cognito user: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case GET_ITEM_DETAIL: {
      dispatch(setLoading(true));
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.updateItem(action.id), axiosConfig);
        dispatch(getItemDetailSuccess(response));
      } catch (e) {
        dispatch(getItemDetailFail(e.message));
        toast.error("Item does not exist.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    /**
     * Share Item
     * { id, recipient, shortUrl, shareId, itemType }
     */
    case SHARE_ITEM: {
      try {
        const userId = getState().auth.cognitoUser.username;
        const { sharedTo, shortUrl, itemType, ctaId } = action;
        const response = await APIManager.Instance.call("POST", APIUrls.shareItem(userId), axiosConfig, {
          itemId: action.id,
          sharedBy: userId,
          sharedTo,
          shortUrl,
          itemType,
          ctaId,
        });
        // add alert status
        const shortInfo = {
          ...response,
          didAlert: false,
        };
        dispatch(shareItemSuccess(shortInfo));
      } catch (e) {
        toast.error("Uh oh. There was an error recording the share: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPVOTE_ITEM: {
      const userId = getState().auth.cognitoUser.username;
      APIManager.Instance.call("POST", APIUrls.upvoteItem(userId), axiosConfig, { itemId: action.id })
        .then(() => {
          dispatch(getItemDetail(action.id));
          dispatch(getUserInfo());
        })
        .catch((e) => {
          toast.error("Failed to upvote the item: " + e.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });

      return next(action);
    }
    case DELETE_UPVOTE_ITEM: {
      const userId = getState().auth.cognitoUser.username;
      APIManager.Instance.call("DELETE", APIUrls.upvoteItem(userId), axiosConfig, { itemId: action.id })
        .then(() => {
          dispatch(getItemDetail(action.id));
          dispatch(getUserInfo());
        })
        .catch((e) => {
          toast.error("Failed to remove upvote: " + e.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });

      return next(action);
    }
    case FAVORITE_ITEM: {
      try {
        const userId = getState().auth.cognitoUser.username;
        await APIManager.Instance.call("POST", APIUrls.favoriteItem(userId), axiosConfig, { itemId: action.id });
        dispatch(getItemDetail(action.id));
        dispatch(getUserInfo());
        // toast.success('Added item to favorites!', {
        //   position: toast.POSITION.TOP_RIGHT
        // });
      } catch (e) {
        toast.error("Failed to favorite: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case DELETE_FAVORITE_ITEM: {
      try {
        const userId = getState().auth.cognitoUser.username;
        await APIManager.Instance.call("DELETE", APIUrls.favoriteItem(userId), axiosConfig, { itemId: action.id });
        dispatch(getItemDetail(action.id));
        dispatch(getUserInfo());
        // toast.success('Removed item from favorites!', {
        //   position: toast.POSITION.TOP_RIGHT
        // });
      } catch (e) {
        toast.error("Failed to remove favorite: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_SETTING: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(action.id, action.listName), axiosConfig, { listValues: action.params });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update account setttings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_FUNNEL_STAGE: {
      try {
        const { funnelStages, id } = getState().settings;
        funnelStages[action.stage.name] = {
          stage: parseInt(action.stage.stage),
          description: action.stage.description,
          importId: action.stage.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "funnelStages"), axiosConfig, { listValues: funnelStages });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update account setttings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_FUNNEL_STAGES: {
      try {
        const { funnelStages, id } = getState().settings;

        action.stages.forEach((stage) => {
          funnelStages[stage.name] = {
            stage: parseInt(stage.stage),
            description: stage.description,
            importId: stage.importId || null,
          };
        });

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "funnelStages"), axiosConfig, { listValues: funnelStages });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update account setttings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_PRODUCT: {
      try {
        const { contentProducts, id } = getState().settings;
        contentProducts[action.product.name] = {
          sort: parseInt(action.product.stage),
          description: action.product.description,
          importId: action.product.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentProducts"), axiosConfig, { listValues: contentProducts });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update account setttings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_PRODUCTS: {
      try {
        const { contentProducts, id } = getState().settings;

        action.products.forEach((product) => {
          contentProducts[product.name] = {
            sort: parseInt(product.stage),
            description: product.description,
            importId: product.importId || null,
          };
        });

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentProducts"), axiosConfig, { listValues: contentProducts });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update account setttings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_INDUSTRY: {
      try {
        const { contentIndustries, id } = getState().settings;
        contentIndustries[action.industry.name] = {
          sort: parseInt(action.industry.stage),
          description: action.industry.description,
          importId: action.industry.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentIndustries"), axiosConfig, { listValues: contentIndustries });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update account setttings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_INDUSTRIES: {
      try {
        const { contentIndustries, id } = getState().settings;

        action.industries.forEach((industry) => {
          contentIndustries[industry.name] = {
            sort: parseInt(industry.stage),
            description: industry.description,
            importId: industry.importId || null,
          };
        });

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentIndustries"), axiosConfig, { listValues: contentIndustries });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update account setttings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_REGION: {
      try {
        const { contentRegions, id } = getState().settings;
        contentRegions[action.region.name] = {
          sort: parseInt(action.region.stage),
          description: action.region.description,
          importId: action.region.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentRegions"), axiosConfig, { listValues: contentRegions });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update account setttings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_REGIONS: {
      try {
        const { contentRegions, id } = getState().settings;

        action.regions.forEach((region) => {
          contentRegions[region.name] = {
            sort: parseInt(region.stage),
            description: region.description,
            importId: region.importId || null,
          };
        });

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentRegions"), axiosConfig, { listValues: contentRegions });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update account setttings: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_FUNNEL_STAGE: {
      try {
        const { funnelStages, id } = getState().settings;
        delete funnelStages[action.stage.originalName];

        funnelStages[action.stage.name] = {
          stage: parseInt(action.stage.stage),
          description: action.stage.description,
          importId: action.stage.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "funnelStages"), axiosConfig, { listValues: funnelStages });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update funnel stage: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_CONTENT_PRODUCT: {
      try {
        const { contentProducts, id } = getState().settings;
        delete contentProducts[action.product.originalName];

        contentProducts[action.product.name] = {
          sort: parseInt(action.product.stage),
          description: action.product.description,
          importId: action.product.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentProducts"), axiosConfig, { listValues: contentProducts });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update funnel stage: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_ACCOUNT_APP_SETTINGS: {
      try {
        let { appOptions, id } = getState().settings;

        if (!appOptions) {
          const newAppOptions = {
            enableIndustries: false,
            enableProducts: false,
          };

          newAppOptions[action.payload.itemName] = action.payload.itemValues;

          const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "appOptions"), axiosConfig, { listValues: newAppOptions });
          dispatch(fetchSettingsSuccess(response.Attributes));
        } else {
          const { id } = getState().settings;

          const response = await APIManager.Instance.call("PUT", APIUrls.accountSettingsDetails(id), axiosConfig, {
            listName: action.payload.listName,
            itemName: action.payload.itemName,
            itemValues: action.payload.itemValues,
          });
          dispatch(fetchSettingsSuccess(response.Attributes));
        }
      } catch (e) {
        toast.error("Failed to update funnel stage: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_CONTENT_INDUSTRY: {
      try {
        const { contentIndustries, id } = getState().settings;
        delete contentIndustries[action.industry.originalName];

        contentIndustries[action.industry.name] = {
          sort: parseInt(action.industry.stage),
          description: action.industry.description,
          importId: action.industry.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentIndustries"), axiosConfig, { listValues: contentIndustries });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update industry: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_CONTENT_REGION: {
      try {
        const { contentRegions, id } = getState().settings;
        delete contentRegions[action.region.originalName];

        contentRegions[action.region.name] = {
          sort: parseInt(action.region.stage),
          description: action.region.description,
          importId: action.region.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentRegions"), axiosConfig, { listValues: contentRegions });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update region: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_TYPE: {
      try {
        const { contentTypes, id } = getState().settings;

        contentTypes[action.content.name] = {
          sort: parseInt(action.content.stage),
          description: action.content.description,
          importId: action.content.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentTypes"), axiosConfig, { listValues: contentTypes });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to add content type: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_TYPES: {
      try {
        const { contentTypes, id } = getState().settings;

        action.types.forEach((type) => {
          contentTypes[type.name] = {
            sort: parseInt(type.stage),
            description: type.description,
            importId: type.importId || null,
          };
        });

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentTypes"), axiosConfig, { listValues: contentTypes });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to add content type: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_CONTENT_TYPE: {
      try {
        const { contentTypes, id } = getState().settings;
        delete contentTypes[action.content.originalName];

        contentTypes[action.content.name] = {
          sort: parseInt(action.content.stage),
          description: action.content.description,
          importId: action.content.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentTypes"), axiosConfig, { listValues: contentTypes });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update content type: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_TAG: {
      try {
        const { contentTags, id } = getState().settings;

        contentTags[action.tag.name] = {
          sort: parseInt(action.tag.sort),
          description: action.tag.description,
          color: action.tag.color,
          importId: action.tag.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentTags"), axiosConfig, { listValues: contentTags });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update content tag: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_CONTENT_TAGS: {
      try {
        const { contentTags, id } = getState().settings;

        action.tags.forEach((tag) => {
          contentTags[tag.name] = {
            sort: parseInt(tag.sort),
            description: tag.description,
            color: tag.color,
            importId: tag.importId || null,
          };
        });

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentTags"), axiosConfig, { listValues: contentTags });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update content tag: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_CONTENT_TAG: {
      try {
        const { contentTags, id } = getState().settings;
        delete contentTags[action.tag.originalName];

        contentTags[action.tag.name] = {
          sort: parseInt(action.tag.sort),
          description: action.tag.description,
          color: action.tag.color,
          importId: action.tag.importId || null,
        };

        const response = await APIManager.Instance.call("PUT", APIUrls.updateAccountSettings(id, "contentTags"), axiosConfig, { listValues: contentTags });
        dispatch(fetchSettingsSuccess(response.Attributes));
      } catch (e) {
        toast.error("Failed to update content tag: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_SHORT_URL: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.updateShortener(action.id), axiosConfig, { path: action.path, newPath: action.newPath });
        dispatch(updateShortUrlSuccess(action.id, response));
        toast.success("Changed the short URL successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } catch (e) {
        const reason = _.get(e, 'response.data.data', e.message);
        toast.error(`Failed to change short URL: ${reason}`, {
          position: toast.POSITION.TOP_RIGHT
        });
      }

      return next(action);
    }
    case UPDATE_SHORT_DOMAIN: {
      try {
        dispatch(setLoading());
        const response = await APIManager.Instance.call("PUT", APIUrls.updateShortDomain(action.id), axiosConfig, action.domainInfo);
        dispatch(updateShortDomainSuccess(response));
        toast.success("Started the custom domain process", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } catch (e) {
        dispatch(updateShortDomainFail(e.message));
        toast.error("Failed to change custom short domain: " + e.response.data.message.replace("Response for Error: Error: ", ""), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case CHANGE_ATTRIBUTE: {
      try {
        await APIManager.Instance.call("PUT", APIUrls.changeAttribute(getState().auth.tenant.tenantId), axiosConfig, action.params);
        const data = await APIManager.Instance.call("GET", APIUrls.getTenant(getState().auth.cognitoUser.attributes.email));
        const { tenant } = data;
        dispatch(loginSuccess(tenant));

        toast.success("Profile saved", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } catch (e) {
        toast.error("Failed to update profile: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case CHANGE_USER_ATTRIBUTE: {
      try {
        await APIManager.Instance.call("PUT", APIUrls.changeUserAttribute(getState().auth.cognitoUser.username), axiosConfig, action.params);

        // update SearchClient with new options
        if (action.params && action.params.name === "searchOptions" && _.get(getState(), "filters.funnelStages", undefined) === undefined) {
          const searchClient = SearchClient.getClient();
          if (searchClient) {
            searchClient.updateSearchOptions(action.params.value);
          }
        }

        dispatch(changeUserAttributeSuccess(action.params));
      } catch (e) {
        toast.error("Failed to update user data: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case INVITE_USER: {
      try {
        await APIManager.Instance.call("POST", APIUrls.inviteUser, axiosConfig, action.params);

        addEventNameToEndpoint(getState().auth.Analytics, "admin-user-invite");
        await getState().auth.Analytics.record({ name: "admin-user-invite", attributes: { email: action.params.email } });
        dispatch(getUsers());

        toast.success(`${action.params.name} is invited to Content Camel`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } catch (e) {
        toast.error("Failed to send invitation: " + e.response ? e.response.data.data.message : e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case DELETE_USER: {
      try {
        await APIManager.Instance.call("DELETE", APIUrls.deleteUser(action.id), axiosConfig);
        addEventNameToEndpoint(getState().auth.Analytics, "admin-user-delete");
        await getState().auth.Analytics.record({ name: "admin-user-delete", attributes: { email: action.email } });
        dispatch(getUsers());

        toast.success(`${action.email} was removed from Content Camel`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } catch (e) {
        toast.error(`Failed to delete ${action.email}: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_USER_ROLE: {
      try {
        await APIManager.Instance.call("PUT", APIUrls.changeUserAttribute(action.id), axiosConfig, action.params);
        addEventNameToEndpoint(getState().auth.Analytics, "admin-user-role-change");
        await getState().auth.Analytics.record({ name: "admin-user-role-change", attributes: { email: action.params.email, role: action.params.value } });
        dispatch(getUsers());

        toast.success(`${action.params.email} changed to ${action.params.value}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } catch (e) {
        toast.error(`Failed to update role of ${action.params.email}: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case GET_USERS: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.getUsers, axiosConfig);
        dispatch(getUsersSuccess(response));
      } catch (e) {
        dispatch(getUsersFail(action.error));

        toast.error("Failed to fetch users: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case GET_USER_INFO: {
      try {
        const userId = getState().auth.cognitoUser.username;
        const response = await APIManager.Instance.call("GET", APIUrls.getUser(userId), axiosConfig);
        if (process.env.REACT_APP_FLAG_CTA === "true") {
          dispatch(getCtasList(response.type));
        }
        dispatch(getUserInfoSuccess(response));
      } catch (e) {
        toast.error("Failed to get user information: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case GET_ACTIVITIES: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.getActivities, axiosConfig);
        dispatch(getActivitiesSuccess(response));
      } catch (e) {
        dispatch(getActivitiesFail(e.message));
        toast.error("Failed to get activities: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case DIGEST_NOTIFICATION_TEST: {
      try {
        await APIManager.Instance.call("GET", APIUrls.testDigestNotification, axiosConfig);
      } catch (e) {
        toast.error("Failed to get send test notifications: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case DELETE_SETTINGS_ITEM: {
      try {
        const response = await APIManager.Instance.call("DELETE", APIUrls.accountSettingsDetails(getState().settings.id), axiosConfig, action.params);
        dispatch(
          deleteSettingsItemSuccess({
            ...action.params,
            data: response.Attributes[action.params.listName][action.params.itemName],
          })
        );
      } catch (e) {
        toast.error("Failed to delete account settings item: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case GET_WISHLIST: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.wishesList, axiosConfig);
        dispatch(getWishsSuccess(response));
      } catch (e) {
        dispatch(getWishsFail(e.message));
        toast.error("Failed to get wishlist: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case GET_WISH_DETAIL: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.wishById(action.id), axiosConfig);
        dispatch(getWishDetailSuccess(response));
      } catch (e) {
        dispatch(getWishDetailFailure(e.message));
        toast.error(`Failed to get wish detail with ${action.id}: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_WISH: {
      try {
        const response = await APIManager.Instance.call("POST", APIUrls.wishes, axiosConfig, action.params);
        dispatch(addWishSuccess(response));
      } catch (e) {
        toast.error("Failed to create wish: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_WISH: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.wishById(action.id), axiosConfig, action.params);
        dispatch(updateWishSuccess(response));
      } catch (e) {
        toast.error("Failed to update wish: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case DELETE_WISH: {
      try {
        const response = await APIManager.Instance.call("DELETE", APIUrls.wishById(action.id), axiosConfig);
        dispatch(deleteWishSuccess(response.id));
      } catch (e) {
        toast.error("Failed to update wish: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case ADD_TAG_TO_ITEM: {
      APIManager.Instance.call("POST", APIUrls.postTagToItem(action.itemId), axiosConfig, { [action.tagName]: action.params })
        .then((itemData) => {
          dispatch(getItemDetailSuccess(itemData));
        })
        .catch((e) => {
          toast.error(`Failed to add ${action.tagName}: ` + e.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });

      return next(action);
    }
    case UPDATE_TAGS_FOR_ITEMS: {
      APIManager.Instance.call("POST", APIUrls.updateTagsForBulkItems, axiosConfig, {
        items: action.itemIds,
        tags: action.tags,
      })
        .then(() => {
          dispatch(getItems());
        })
        .catch((e) => {
          toast.error(`Failed to update tags: ` + e.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });

      return next(action);
    }
    case REMOVE_TAG_FROM_ITEM: {
      APIManager.Instance.call("DELETE", APIUrls.deleteTagFromItem(action.itemId, action.tagName), axiosConfig)
        .then((itemData) => {
          dispatch(getItemDetailSuccess(itemData));
        })
        .catch((e) => {
          toast.error(`Failed to remove ${action.tagName}: ` + e.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        });

      return next(action);
    }
    case ADD_UPVOTE_WISH: {
      try {
        const response = await APIManager.Instance.call("POST", APIUrls.wishUpvote(action.id), axiosConfig, {});
        dispatch(addUpvoteWishSuccess(response));
      } catch (e) {
        toast.error(`Failed to add upvote to wish: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case DELETE_UPVOTE_WISH: {
      try {
        const response = await APIManager.Instance.call("DELETE", APIUrls.wishUpvote(action.id), axiosConfig);
        dispatch(deleteUpvoteWishSuccess(response));
      } catch (e) {
        toast.error(`Failed to add upvote to wish: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case GET_IMPORT_HISTORY: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.getImportHistory, axiosConfig);
        dispatch(getImportHistorySuccess(response));
      } catch (e) {
        toast.error(`Failed to get import history: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(getImportHistoryFailure(e.message));
      }

      return next(action);
    }
    case CREATE_IMPORT_HISTORY: {
      try {
        const response = await APIManager.Instance.call("POST", APIUrls.getImportHistory, axiosConfig, action.historyData);
        dispatch(createImportHistorySuccess(response));
      } catch (e) {
        toast.error(`Failed to create an import history: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(createImportHistoryFailure(e.message));
      }

      return next(action);
    }
    case UPDATE_HISTORY_STATUS: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.updateImportHistoryStatus, axiosConfig, { status: action.status, importId: action.importId });
        dispatch(updateHistoryStatusSuccess(response));
      } catch (e) {
        toast.error(`Failed to update status an import history: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(updateHistoryStatusFailure(e.message));
      }

      return next(action);
    }
    case DELETE_IMPORT_HISTORY: {
      try {
        const response = await APIManager.Instance.call("DELETE", APIUrls.deleteImportHistory(action.importId), axiosConfig);
        dispatch(deleteImportHistorySuccess(response));
      } catch (e) {
        toast.error(`Failed to delete import history: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(deleteImportHistoryFailure(e.message));
      }

      return next(action);
    }
    case GET_INVOICES: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.getInvoices(action.customerId), axiosConfig);
        dispatch(getInvoicesSuccess(response));
      } catch (e) {
        toast.error(`Failed to delete import history: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(getInvoicesFail(e.message));
      }

      return next(action);
    }
    case UPDATE_DIGEST_OPTION: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.updateDigestOption(getState().settings.id), axiosConfig, { digestOption: action.digestOption });
        dispatch(updateDigestOptionSuccess(response));
      } catch (e) {
        toast.error(`Failed to update digest option: ` + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(updateDigestOptionFail(e.message));
      }

      return next(action);
    }
    case CREATE_NEW_COLLECTION: {
      try {
        const response = await APIManager.Instance.call("POST", APIUrls.createCollection, axiosConfig, action.params);
        StateMachineManager.Instance.service.send("SWITCH_COLLECTION_EDITING", { collection: response.collections[response.collections.length - 1] });
        dispatch(getUserSiteContentSuccess(response));
      } catch (e) {
        toast.error("Failed to create a new collection" + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(createNewCollectionFail(e.message));
      }

      return next(action);
    }
    case UPDATE_COLLECTION: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.deleteCollection(action.id), axiosConfig, action.params);
        dispatch(getUserSiteContentSuccess(response));
      } catch (e) {
        toast.error("Failed to update collection" + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case DELETE_COLLECTION: {
      try {
        const response = await APIManager.Instance.call("DELETE", APIUrls.deleteCollection(action.collection.id), axiosConfig);
        dispatch(getUserSiteContentSuccess(response));
      } catch (e) {
        toast.error("Failed to delete collection", {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(deleteCollectionFail(e.message));
      }

      return next(action);
    }
    case GET_COLLECTIONS: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.createCollection, axiosConfig);
        dispatch(getCollectionsSuccess(response));
      } catch (e) {
        toast.error("Failed to get collections: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(getCollectionsFail(e.message));
      }

      return next(action);
    }
    case GET_COLLECTION: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.deleteCollection(action.id), axiosConfig);
        dispatch(getCollectionSuccess(response));
      } catch (e) {
        toast.error("Failed to get collections: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(getCollectionFail(e.message));
      }

      return next(action);
    }
    case ADD_ITEM_TO_COLLECTION: {
      try {
        const response = await APIManager.Instance.call("POST", APIUrls.addItemToCollection(action.itemId, action.collectionId), axiosConfig);
        dispatch(getUserSiteContentSuccess(response));
      } catch (e) {
        toast.error("Failed to get collections: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(getCollectionFail(e.message));
      }

      return next(action);
    }
    case REMOVE_ITEM_FROM_COLLECTION: {
      try {
        const response = await APIManager.Instance.call("DELETE", APIUrls.addItemToCollection(action.itemId, action.collectionId), axiosConfig);
        dispatch(getUserSiteContentSuccess(response));
      } catch (e) {
        toast.error("Failed to get collections: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(getCollectionFail(e.message));
      }

      return next(action);
    }
    case UPDATE_ITEMS_OF_COLLECTION: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.updateItemsOfCollection(action.collectionId), axiosConfig, {
          items: action.items,
          sharedBy: action.sharedBy,
          sharedWith: action.sharedWith,
        });
        dispatch(getUserSiteContentSuccess(response));
      } catch (e) {
        toast.error("Failed to get collections: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(getCollectionFail(e.message));
      }

      return next(action);
    }
    case CREATE_SITE: {
      try {
        const response = await APIManager.Instance.call("POST", APIUrls.createSite, axiosConfig, action.params);
        // the site added is the last one
        dispatch(createSiteSuccess(response.sites[response.sites.length - 1]));
        // broadcast new collections and sites
        dispatch(getUserSiteContentSuccess(response));
      } catch (e) {
        toast.error("Failed to create site: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(createSiteFail(e.message));
      }

      return next(action);
    }
    case GET_USER_SITE_CONTENT: {
      try {
        const response = await APIManager.Instance.call("GET", APIUrls.getUserSiteContent, axiosConfig);
        dispatch(getUserSiteContentSuccess(response));
      } catch (e) {
        toast.error("Failed to get user site information: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(getUserSiteCOntentFail(e.message));
      }

      return next(action);
    }
    case DELETE_SITE: {
      try {
        const response = await APIManager.Instance.call("DELETE", APIUrls.deleteSite(action.id), axiosConfig);
        dispatch(getUserSiteContentSuccess(response));
      } catch (e) {
        toast.error("Failed to delete site: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        dispatch(deleteSiteFail(e.message));
      }

      return next(action);
    }
    case UPDATE_BRANDING_COLOR: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.updateBrandingColor, axiosConfig, { color: action.color });
        dispatch(fetchSettingsSuccess(response));
      } catch (e) {
        toast.error("Failed to update branding color: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_TRACKERS: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.updateTrackers, axiosConfig, action.params);
        dispatch(fetchSettingsSuccess(response));
      } catch (e) {
        toast.error("Failed to update trackers: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case GET_CTAS_LIST: {
      try {
        const response = await APIManager.Instance.call("GET", `${APIUrls.listCta}?type=${action.userType}`, axiosConfig);
        dispatch(getCtasListSuccess(response));
      } catch (e) {
        toast.error("Failed to get ctas: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case CREATE_CTA: {
      try {
        const response = await APIManager.Instance.call("POST", APIUrls.listCta, axiosConfig, action.ctaData);
        dispatch(getCtasListSuccess(response));
      } catch (e) {
        toast.error("Failed to create cta: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_CTA: {
      try {
        const response = await APIManager.Instance.call("PUT", APIUrls.updateCta(action.ctaId), axiosConfig, action.ctaData);
        dispatch(getCtasListSuccess(response));
      } catch (e) {
        toast.error("Failed to update cta: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case DELETE_CTA: {
      try {
        await APIManager.Instance.call("DELETE", APIUrls.updateCta(action.ctaId), axiosConfig);
        dispatch(deleteCtaSuccess(action.ctaId));
      } catch (e) {
        toast.error("Failed to delete cta: " + e.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return next(action);
    }
    case UPDATE_TENANT:
    case USER_LOGOUT: {
      return next(action);
    }
    default: {
      return next(action);
    }
  }
}

export default AuthorizedMiddleware;
